// Calculate opacity and transform based on element position
export const getElementAnimation = (element: HTMLElement | null) => {
  if (!element) return { opacity: 0, transform: 'translateY(50px)' };

  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const elementCenter = rect.top + rect.height / 2;
  const screenCenter = windowHeight / 2;

  // Calculate distance from center of screen
  const distance = Math.abs(elementCenter - screenCenter);
  const maxDistance = windowHeight / 2;

  // Element is visible when distance is less than maxDistance
  if (distance > maxDistance) {
    return { opacity: 0, transform: 'translateY(50px)' };
  }

  // More aggressive fade-in: opacity reaches 1 much faster
  const rawOpacity = 1 - (distance / maxDistance);
  const opacity = Math.pow(rawOpacity, 0.15); // Very aggressive power curve for instant fade-in
  const translateY = (distance / maxDistance) * 30;

  return {
    opacity: Math.max(0, Math.min(1, opacity)),
    transform: `translateY(${translateY}px)`,
  };
};
